import cz from '../csCZ/contact';

const en: typeof cz = {
	page_title: 'Contact form',
	address_label: 'Address',
	address_part_1: 'Přední 2, 618 00 Brno–Černovice',
	address_part_2: 'Nová radnice, Dominikánské nám. 1, 601 67 Brno',
	mobile_label: 'Phone',
	email_label: 'E-mail',
};

export default en;
